import React, { useState, useEffect } from 'react';
import { Briefcase, GraduationCap, Loader2 } from 'lucide-react';
import api from '../services/api';

const TutorSection = () => {
    const [mentors, setMentors] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMentors = async () => {
            try {
                const response = await api.get('/mentors');
                setMentors(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                console.error("Failed to fetch mentors:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMentors();
    }, []);

    if (loading) {
        return (
            <div className="bg-brand-card py-20 flex justify-center items-center blur-sm">
                <Loader2 className="w-8 h-8 animate-spin text-brand-gold" />
            </div>
        );
    }

    if (!mentors || mentors.length === 0) {
        return null;
    }
    return (
        <div className="bg-brand-card py-20">
            <div className="max-w-7xl mx-auto px-6">
                <div className="mb-12 text-center">
                    <span className="inline-block px-4 py-1.5 rounded-full bg-brand-bg text-brand-gold font-semibold text-sm mb-4 border border-gray-800">
                        Game Changers
                    </span>
                    <h2 className="text-3xl font-bold text-brand-textMuted">
                        Meet our Mentors
                    </h2>
                    <div className="w-24 h-1 bg-brand-gold mt-2 rounded-full mx-auto"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {mentors.map((tutor, index) => {
                        if (!tutor) return null;
                        return (
                            <div key={index} className="bg-brand-card rounded-2xl border border-gray-800 overflow-hidden hover:border-brand-gold shadow-xl transition-all duration-300 group">
                                {/* Top Colored Section */}
                                <div className="h-32 bg-brand-bg relative border-b border-gray-800">
                                    <div className="absolute top-4 left-4">
                                        <div className="w-12 h-12 rounded-full bg-brand-gold/10 blur-xl"></div>
                                    </div>
                                </div>

                                {/* Image - Overlapping */}
                                <div className="px-6 relative -mt-16 mb-4 text-center">
                                    <div className="w-32 h-32 mx-auto rounded-full p-1 bg-brand-card shadow-md">
                                        <img
                                            src={tutor.image || ''}
                                            alt={tutor.name}
                                            className="w-full h-full object-cover rounded-full"
                                        />
                                    </div>
                                </div>

                                {/* Info Section */}
                                <div className="px-6 pb-6 text-center">
                                    <h3 className="text-lg font-bold text-brand-textLight">{tutor.name}</h3>
                                    <p className="text-brand-textMuted text-sm mb-6">{tutor.role}</p>

                                    <div className="border-t border-gray-800 my-4"></div>

                                    {/* Stats */}
                                    <div className="flex justify-between items-center mb-6 px-1">
                                        <div className="text-left">
                                            <div className="flex items-center gap-1.5 mb-1">
                                                <Briefcase className="w-4 h-4 text-brand-textMuted" />
                                                <span className="font-bold text-brand-textLight text-sm">{tutor.workExp}</span>
                                            </div>
                                            <p className="text-[10px] text-brand-textMuted uppercase tracking-wide font-medium">Work Experience</p>
                                        </div>
                                        <div className="h-8 w-px bg-gray-800"></div>
                                        <div className="text-left">
                                            <div className="flex items-center gap-1.5 mb-1">
                                                <GraduationCap className="w-4 h-4 text-brand-textMuted" />
                                                <span className="font-bold text-brand-textLight text-sm">{tutor.teachingExp}</span>
                                            </div>
                                            <p className="text-[10px] text-brand-textMuted uppercase tracking-wide font-medium">Teaching Exp</p>
                                        </div>
                                    </div>

                                    {/* Bio */}
                                    <p className="text-brand-textMuted text-xs leading-relaxed text-left line-clamp-3">
                                        {tutor.bio}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TutorSection;
